import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_ADMIN_ADD_ASSIGNED_USER,
  API_DELETE_ADMIN_ASSIGNED_USER,
  API_DELETE_ADMIN_ROLE,
  API_GET_ADMIN_ASSIGNED_USERS,
  API_GET_ADMIN_AUDIT_LOG,
  API_GET_ADMIN_PERMISSIONS,
  API_GET_ADMIN_ROLE,
  API_GET_ALL_ADMIN_ROLES_NAMES,
  API_GET_ALL_ADMIN_USERS,
  API_POST_ADMIN_ROLE_CREATE,
  API_UPDATE_ADMIN_ASSIGNED_USER,
  API_UPDATE_ADMIN_ROLE,
} from "../../Apis/ApiEndPoints";
import {
  IAdminAssignedRolesRequestBody,
  IAdminRolesRequestBody,
} from "./roleAndPermissionType";
import { IGetAllAdminRolesResponse } from "../../models/admin/userManagement/userManagement";

export const adminGetRoles = createAsyncThunk(
  "roles/adminGetRoles",
  async (_, { dispatch }) => {
    const response = await CustomAction(
      Api.get(API_GET_ADMIN_ROLE),
      dispatch,
      "roles/adminGetRoles"
    );
    return response;
  }
);

export const getAdminAuditLog = createAsyncThunk(
  "roles/getAdminAuditLog",
  async (_, { dispatch }) => {
    const response = await CustomAction(
      Api.get(API_GET_ADMIN_AUDIT_LOG),
      dispatch,
      "roles/getAdminAuditLog"
    );
    return response;
  }
);

export const getAdminPermissionsByName = createAsyncThunk(
  "roles/adminGetPermission",
  async (name: string, { dispatch }) => {
    const url = `${API_GET_ADMIN_PERMISSIONS}/${name}`;

    const response = await CustomAction(
      Api.get(url),
      dispatch,
      "roles/adminGetPermission"
    );

    return response;
  }
);

export const getAdminAssignedUsers = createAsyncThunk(
  "roles/getAdminAssignedUsers",
  async (name: string, { dispatch }) => {
    const encodedName = encodeURIComponent(name);
    const url = `${API_GET_ADMIN_ASSIGNED_USERS}/${encodedName}`;

    const response = await CustomAction(
      Api.get(url),
      dispatch,
      "roles/getAdminAssignedUsers"
    );

    return response;
  }
);

export const getAllAdminUsers = createAsyncThunk(
  "roles/getAllAdminUsers",
  async (_, { dispatch }) => {
    const url = `${API_GET_ALL_ADMIN_USERS}`;

    const response = await CustomAction(
      Api.get(url),
      dispatch,
      "roles/getAllAdminUsers"
    );

    return response;
  }
);

export const adminCreateRoles = createAsyncThunk(
  "roles/adminCreateRoles",
  async (requestBody: IAdminRolesRequestBody, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_ADMIN_ROLE_CREATE, requestBody),
      dispatch,
      "roles/adminCreateRoles"
    );

    return response;
  }
);

export const adminUpdateRoles = createAsyncThunk(
  "roles/adminUpdateRoles",
  async (requestBody: IAdminRolesRequestBody, { dispatch }) => {
    const response = await CustomAction(
      Api.put(API_UPDATE_ADMIN_ROLE, requestBody),
      dispatch,
      "roles/adminUpdateRoles"
    );

    return response;
  }
);

export const deleteAdminRole = createAsyncThunk(
  "roles/deleteAdminRole",
  async (name: string, { dispatch }) => {
    const response = await CustomAction(
      Api.delete(`${API_DELETE_ADMIN_ROLE}/${name}`),
      dispatch,
      "roles/deleteAdminRole"
    );
    return response;
  }
);

export const adminAddAssignedUser = createAsyncThunk(
  "roles/adminAddAssignedUser",
  async (requestBody: { role: string; emails: string[] }, { dispatch }) => {
    const { role, emails } = requestBody;

    const encodedRole = encodeURIComponent(role);
    const url = `${API_ADMIN_ADD_ASSIGNED_USER}/${encodedRole}`;

    const response = await CustomAction(
      Api.post(url, emails),
      dispatch,
      "roles/adminAddAssignedUser"
    );

    return response;
  }
);

export const adminUpdateAssignedUser = createAsyncThunk(
  "roles/adminUpdateAssignedUser",
  async (
    requestBody: { currentRole: string; user: string; addRoles: string[] },
    { dispatch }
  ) => {
    const { currentRole, user, addRoles } = requestBody;

    const encodedRole = encodeURIComponent(currentRole);
    const encodedUser = encodeURIComponent(user);

    const url = `${API_UPDATE_ADMIN_ASSIGNED_USER}/${encodedRole}/${encodedUser}`;

    const response = await CustomAction(
      Api.put(url, addRoles),
      dispatch,
      "roles/adminUpdateAssignedUser"
    );

    return response;
  }
);

export const adminDeleteAssignedUser = createAsyncThunk(
  "roles/adminDeleteAssignedUser",
  async (requestBody: { user: string; role: string }, { dispatch }) => {
    const { role, user } = requestBody;
    const encodedRole = encodeURIComponent(role);
    const encodedEmail = encodeURIComponent(user);
    const url = `${API_DELETE_ADMIN_ASSIGNED_USER}/${encodedRole}/${encodedEmail}`;

    const response = await CustomAction(
      Api.delete(url),
      dispatch,
      "roles/adminDeleteAssignedUser"
    );
    return response;
  }
);

export const getUnAssignedRoles = createAsyncThunk(
  "roles/getUnAssignedRoles",
  async (email: string, { dispatch }) => {
    const response: IGetAllAdminRolesResponse = await CustomAction(
      Api.get(`${API_GET_ALL_ADMIN_ROLES_NAMES}/${email}`),
      dispatch,
      "roles/getUnAssignedRoles"
    );
    return response;
  }
);
